export const SEARCH_API_DEV = 'https://dexter-dev.ecomm.pixartprinting.net/api/v1/imgbrowser';
export const SEARCH_API_PROD = 'https://dexter.ecomm.pixartprinting.net/api/v1/imgbrowser';
